import type { ReactNode } from 'react';
import desertoursLogo from '../../assets/desertours-logo.png';

/**
 * Layout commun pour toutes les pages d'authentification
 * Centralise la structure et les styles pour éviter la duplication
 */

interface AuthLayoutProps {
  children: ReactNode;
  icon?: ReactNode;
  title: string;
  subtitle: string;
}

export function AuthLayout({ children, icon, title, subtitle }: AuthLayoutProps) {
  return (
    <div className="bg-white min-h-screen flex items-center justify-center">
      <div className="flex flex-col gap-[1.5rem] items-center justify-start max-w-[24rem] w-[24rem]">
        {/* Logo ou Icône */}
        {icon ? (
          <div className="overflow-clip relative shrink-0 size-[2rem]">{icon}</div>
        ) : (
          <img
            src={desertoursLogo}
            alt="Desertours Logo"
            className="shrink-0 size-[3rem] object-cover"
          />
        )}

        {/* Header */}
        <div className="flex flex-col gap-[0.75rem] items-start justify-start text-center w-full">
          <div className="font-bold text-[1.875rem] text-zinc-950 w-full leading-[2.25rem]">
            {title}
          </div>
          <div className="font-normal text-[0.875rem] text-zinc-500 w-full leading-[1.25rem]">
            {subtitle}
          </div>
        </div>

        {/* Contenu */}
        {children}
      </div>
    </div>
  );
}
